import { useQuery } from '@tanstack/react-query';
import { fetchCaseGraph } from '../api/graph';

/**
 * Fetches the Cytoscape-compatible graph for a case's connected component.
 * Returns { elements: { nodes, edges }, prime_suspect_id, member_count, ... }
 */
export const useCaseGraph = (caseNumber) => {
  return useQuery({
    queryKey: ['case-graph', caseNumber],
    queryFn: () => fetchCaseGraph(caseNumber),
    enabled: Boolean(caseNumber),
    staleTime: 60_000, // graph data changes less frequently
  });
};
